/**
 * Utilitário para gerenciar a atualização das safe-areas quando ocorrer rotação do dispositivo
 */

/**
 * Inicializa o monitoramento de mudanças de orientação para atualizar as safe-areas
 */
export const initSafeAreaUpdates = () => {
  // Verifica se está em um ambiente de navegador
  if (typeof window === 'undefined') return;
  
  // Função para atualizar a altura da viewport em iOS
  const updateViewportHeight = () => {
    // Só é necessário em iOS
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      // Pequeno atraso para garantir que a UI tenha tempo de atualizar
      setTimeout(() => {
        // Altura da janela
        const vh = window.innerHeight * 0.01;
        // Definir variável CSS personalizada
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      }, 100);
    }
  };
  
  // Atualiza imediatamente na carga
  updateViewportHeight();
  
  // Atualiza ao girar o dispositivo
  window.addEventListener('orientationchange', () => {
    // Pequeno atraso para permitir que a rotação seja concluída
    setTimeout(updateViewportHeight, 200);
  });
  
  // Atualiza no redimensionamento da janela
  window.addEventListener('resize', updateViewportHeight);
  
  // Forçar atualização ao carregar a página
  document.addEventListener('DOMContentLoaded', updateViewportHeight);
  
  // Lidar com mudanças na barra de navegação em iOS
  window.visualViewport?.addEventListener('resize', updateViewportHeight);
  
  return () => {
    // Função de limpeza
    window.removeEventListener('orientationchange', updateViewportHeight);
    window.removeEventListener('resize', updateViewportHeight);
    document.removeEventListener('DOMContentLoaded', updateViewportHeight);
    window.visualViewport?.removeEventListener('resize', updateViewportHeight);
  };
};

/**
 * Aplica a altura da viewport corretamente para iOS
 */
export const applySafeAreaInsets = () => {
  // Aplicar o --vh no elemento raiz
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  
  // Para dispositivos com notch, adicione classe específica
  if (window.innerHeight >= 812 && /iPhone|iPad|iPod/.test(navigator.userAgent)) {
    document.documentElement.classList.add('has-notch');
  }
};

/**
 * Verifica se o aplicativo está sendo executado no modo standalone (PWA instalado)
 * @returns {boolean} True se estiver no modo standalone
 */
export const isInStandaloneMode = () => {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone ||
    document.referrer.includes('android-app://')
  );
};

export default {
  initSafeAreaUpdates,
  applySafeAreaInsets,
  isInStandaloneMode
}; 